/* Greenleaf — the bag drawer after Add to bag. New 9 Sep 2026.
 *
 * Loaded from snippets/gl-cart-drawer.liquid, which layout/theme.liquid renders
 * on every page except /cart (12 Oct 2026; before that only on product pages).
 * It also opens from the header's bag icon (fetching /cart.js) and lets a line be
 * removed in place (/cart/change.js). Without script every bag link is still a plain
 * link to /cart. Both product forms on that page
 * (the info column and the mobile sticky bar) post to /cart/add and, without
 * this script, land on /cart. That is still the fallback: this intercepts the
 * submit, posts the same form to /cart/add.js, fetches /cart.js and draws the
 * bag into the drawer. Any failure that is not a Shopify answer falls back to
 * a plain form.submit(), which skips this listener and goes to /cart.
 *
 * PRICES ARE WHOLE DOLLARS unless there are cents to show — the same rule as
 * `money_without_trailing_zeros` on the cart page and the product page, so a
 * $22,110 ring does not turn into $22,110.00 the moment it enters the bag.
 * The currency comes from /cart.js, not from a hardcoded symbol.
 *
 * NO innerHTML WITH CART DATA. Titles come from the store and are written with
 * textContent; the only markup here is built with createElement.
 *
 * THE HEADER'S BAG COUNT is server-rendered as "Bag (N)" in gl-header.liquid,
 * twice (the masthead and the mobile menu). Both are updated in place so the
 * count agrees with the drawer without a page load.
 */
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-bag-drawer]');
    if (!drawer || !window.fetch || !window.FormData) return;

    var panel = drawer.querySelector('[data-bag-panel]');
    var lines = drawer.querySelector('[data-bag-lines]');
    var total = drawer.querySelector('[data-bag-total]');
    var status = drawer.querySelector('[data-bag-status]');
    var titleEl = drawer.querySelector('[data-bag-title]');
    var emptyEl = drawer.querySelector('[data-bag-empty]');
    var footEl = drawer.querySelector('[data-bag-foot]');
    if (!panel || !lines || !total) return;

    var currency = 'USD';
    var opener = null;

    // ---- money -----------------------------------------------------------
    function money(cents) {
      var whole = cents % 100 === 0;
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: whole ? 0 : 2,
          maximumFractionDigits: whole ? 0 : 2
        }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(whole ? 0 : 2);
      }
    }

    // ---- markup ----------------------------------------------------------
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    // Shopify's CDN sizes an image by query parameter, so a 200px thumbnail is
    // fetched for a 72px slot rather than the full upload.
    function thumb(url) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=200';
    }

    function render(cart) {
      currency = cart.currency || currency;
      if (sugEl) { sugEl.setAttribute('hidden', ''); sugToken++; }
      lines.textContent = '';
      (cart.items || []).forEach(function (item) {
        var row = el('div', 'line');
        if (item.image) {
          var img = el('img', 'slot');
          img.src = thumb(item.image);
          img.alt = '';
          img.width = 72;
          img.height = 72;
          row.appendChild(img);
        } else {
          row.appendChild(el('span', 'slot slot--square'));
        }
        var body = el('div');
        var name = el('a', 'line__name', item.product_title);
        name.href = item.url;
        body.appendChild(name);
        if (item.variant_title && item.variant_title !== 'Default Title') {
          body.appendChild(el('span', 'line__meta', item.variant_title));
        }
        if (item.quantity > 1) {
          body.appendChild(el('span', 'line__meta', 'Quantity ' + item.quantity));
        }
        var rm = el('button', 'bagdrawer__remove', 'Remove');
        rm.type = 'button';
        rm.setAttribute('aria-label', 'Remove ' + item.product_title + ' from your bag');
        rm.setAttribute('data-bag-remove', item.key);
        body.appendChild(rm);
        row.appendChild(body);
        row.appendChild(el('span', 'line__price', money(item.final_line_price)));
        lines.appendChild(row);
      });
      var any = (cart.items || []).length > 0;
      if (emptyEl) { if (any) emptyEl.setAttribute('hidden', ''); else emptyEl.removeAttribute('hidden'); }
      if (!any) recentRow();
      if (footEl) { if (any) footEl.removeAttribute('hidden'); else footEl.setAttribute('hidden', ''); }
      total.textContent = money(cart.total_price || 0);
      checkCase(cart);
      textUs(cart);
      updateHeader(cart.item_count || 0);
    }

    // ---- "Everything here is in the case in Wailea" (12 Oct 2026) -----------
    // Shown only when EVERY item is an in-stock piece: none sold, none tagged
    // made-to-order or pre-order, none a gift card. /cart.js does not carry tags,
    // so each piece is read from /products/<handle>.js (cached). Hidden first and
    // shown only once all of them check out; any failure leaves it hidden. The
    // pre-order TEMPLATE itself cannot be read from the browser, so a pre-order
    // piece must carry the tag to be caught.
    var caseEl = drawer.querySelector('[data-bag-case]');
    var caseToken = 0, caseCache = {};
    // A piece that is gone (404) is remembered as null. A failed request (network, 429, 5xx) is NOT:
    // it is forgotten at once, so the next time the bag opens it is asked again instead of hiding the
    // case line and "Pieces you looked at" for the rest of the page (audit, 15 Oct 2026).
    function info(handle) {
      if (!caseCache[handle]) {
        var p = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) {
            if (r.ok) return r.json();
            if (r.status === 404) return null;
            throw new Error('product ' + r.status);
          })
          .catch(function () { if (caseCache[handle] === p) delete caseCache[handle]; return null; });
        caseCache[handle] = p;
      }
      return caseCache[handle];
    }
    function madeToOrder(tags) {
      return (tags || []).some(function (t) { return /^(made[- ]to[- ]order|pre[- ]?order)$/i.test(String(t).trim()); });
    }
    function checkCase(cart) {
      if (!caseEl) return;
      var mine = ++caseToken;
      caseEl.setAttribute('hidden', '');
      var items = cart.items || [];
      if (!items.length) return;
      for (var i = 0; i < items.length; i++) { if (items[i].gift_card || !items[i].handle) return; }
      Promise.all(items.map(function (it) { return info(it.handle); })).then(function (res) {
        if (mine !== caseToken) return;
        var ok = res.every(function (p) { return p && p.available && !madeToOrder(p.tags); });
        if (ok) caseEl.removeAttribute('hidden');
      });
    }

    // ---- one "Wear it with" row (13 Oct 2026, Andrew) ---------------------------------
    // Under what was just added: ONE matching piece from the product's existing
    // complementary list (the same list that feeds "Wear it with" on the product page).
    // Only a piece that is in stock and not already in the bag. Plain row: photo, name,
    // price, and an "Add" text link. Any failure, or no match, leaves it hidden. Text is
    // written with textContent; nothing from the store goes in as markup.
    var sugEl = drawer.querySelector('[data-bag-suggest]');
    var sugToken = 0;
    function suggest(cart) {
      if (!sugEl) return;
      var mine = ++sugToken;
      sugEl.setAttribute('hidden', '');
      sugEl.textContent = '';
      var items = cart.items || [];
      if (!items.length || !items[0].product_id) return;
      var inBag = {};
      items.forEach(function (it) { inBag[it.product_id] = true; });
      fetch('/recommendations/products.json?product_id=' + items[0].product_id + '&limit=8&intent=complementary', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (mine !== sugToken || !data) return;
          var pick = null;
          (data.products || []).some(function (p) {
            if (p.available && !inBag[p.id] && p.variants && p.variants.length && p.variants[0].available && (p.featured_image || (p.images && p.images[0]))) { pick = p; return true; }
            return false;
          });
          if (!pick) return;
          var v = pick.variants[0];
          var src = pick.featured_image || pick.images[0];
          if (src && typeof src === 'object') src = src.src || src.url;
          sugEl.appendChild(el('p', 'bagsuggest__head', 'Wear it with'));
          var row = el('div', 'bagsuggest__row');
          var img = el('img');
          img.src = thumb(src); img.alt = ''; img.width = 72; img.height = 72; img.loading = 'lazy';
          row.appendChild(img);
          var body = el('div');
          var nm = el('a', 'bagsuggest__name', pick.title);
          nm.href = pick.url;
          body.appendChild(nm);
          var pr = typeof pick.price === 'string' ? Math.round(parseFloat(pick.price) * 100) : pick.price;
          body.appendChild(el('span', 'bagsuggest__price', money(pr)));
          row.appendChild(body);
          var add = el('button', 'bagsuggest__add', 'Add');
          add.type = 'button';
          add.setAttribute('aria-label', 'Add ' + pick.title + ' to your bag');
          add.addEventListener('click', function () {
            add.disabled = true;
            fetch('/cart/add.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
            })
              .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }); })
              .then(function (r) { return r.json(); })
              .then(function (c) { render(c); setTitle('Added to your bag'); setStatus(''); added(null); }, function () { add.disabled = false; });
          });
          row.appendChild(add);
          sugEl.appendChild(row);
          sugEl.removeAttribute('hidden');
        })
        .catch(function () {});
    }

    // ---- "Pieces you looked at" in an empty bag (13 Oct 2026, Andrew) ------------------
    // The same remembered list the product pages keep (localStorage `gl.recent`, handles only,
    // written by sections/gl-recent.liquid). Up to four pieces that are still for sale, as plain
    // rows. Nothing remembered, storage off or any failure: nothing is drawn and the empty bag
    // reads as before. Text goes in with textContent.
    var recentEl = drawer.querySelector('[data-bag-recent]');
    var recentToken = 0;
    function recentRow() {
      if (!recentEl) return;
      var mine = ++recentToken;
      recentEl.textContent = '';
      recentEl.setAttribute('hidden', '');
      var list = [];
      try { list = JSON.parse(window.localStorage.getItem('gl.recent') || '[]'); } catch (e) { return; }
      if (!Array.isArray(list)) return;
      list = list.filter(function (h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(h); }).slice(0, 8);
      if (!list.length) return;
      // Asked three at a time, in the order remembered, and only until four for-sale pieces are found
      // (it was all eight at once on every empty bag).
      var found = [];
      function next(i) {
        if (mine !== recentToken) return;
        if (found.length >= 4 || i >= list.length) { draw(found); return; }
        Promise.all(list.slice(i, i + 3).map(function (h) { return info(h); })).then(function (res) {
          res.forEach(function (p) { if (p && p.available && found.length < 4) found.push(p); });
          next(i + 3);
        });
      }
      next(0);
      function draw(res) {
        if (mine !== recentToken) return;
        var shown = 0;
        res.forEach(function (p) {
          if (!p || !p.available || shown >= 4) return;
          if (!shown) recentEl.appendChild(el('p', 'bagsuggest__head', 'Pieces you looked at'));
          var row = el('a', 'bagrecent__row');
          row.href = p.url;
          var src = p.featured_image || (p.images && p.images[0]);
          if (src) { var im = el('img'); im.src = thumb(src); im.alt = ''; im.width = 56; im.height = 56; im.loading = 'lazy'; row.appendChild(im); }
          var body = el('span', 'bagrecent__body');
          body.appendChild(el('span', 'bagsuggest__name', p.title));
          body.appendChild(el('span', 'bagsuggest__price', money(p.price)));
          row.appendChild(body);
          recentEl.appendChild(row);
          shown++;
        });
        if (shown) recentEl.removeAttribute('hidden');
      }
    }

    // ---- "Added" (12 Oct 2026) -------------------------------------------------
    // After an add that Shopify took, the button reads "Added" for about 1.5 s and the
    // header count bumps once (CSS in assets/gl-touches.css; the bump is off under
    // reduced motion). The word is also spoken through a polite live region, because a
    // changed button label is not announced on its own.
    var said = document.createElement('div');
    said.className = 'sr';
    said.setAttribute('role', 'status');
    said.setAttribute('aria-live', 'polite');
    document.body.appendChild(said);
    function added(button) {
      if (button && button.tagName === 'BUTTON' && !button.__glAdded) {
        button.__glAdded = true;
        var was = button.textContent;
        button.textContent = 'Added';
        setTimeout(function () { button.textContent = was; button.__glAdded = false; }, 1500);
      }
      said.textContent = '';
      setTimeout(function () { said.textContent = 'Added to your bag'; }, 50);
      setTimeout(function () { said.textContent = ''; }, 3000);
      var badges = document.querySelectorAll('.mastlink__count');
      Array.prototype.forEach.call(badges, function (b) {
        b.classList.remove('is-bump');
        void b.offsetWidth;
        b.classList.add('is-bump');
        setTimeout(function () { b.classList.remove('is-bump'); }, 600);
      });
    }

    function setTitle(text) { if (titleEl) titleEl.textContent = text; }

    function setStatus(message) {
      if (!status) return;
      status.textContent = message || '';
      if (message) status.removeAttribute('hidden');
      else status.setAttribute('hidden', '');
    }

    // ---- header count ----------------------------------------------------
    function updateHeader(count) {
      var label = count > 0 ? 'Bag (' + count + ')' : 'Bag';
      var aria = count > 0 ? 'Bag, ' + count + (count === 1 ? ' item' : ' items') : 'Bag';
      var links = document.querySelectorAll('a[href$="/cart"]');
      Array.prototype.forEach.call(links, function (a) {
        // The masthead's icon carries a small count badge (12 Oct 2026: it must follow a removal too).
        if (a.classList.contains('mastlink--icon')) {
          var badge = a.querySelector('.mastlink__count');
          if (count > 0) {
            if (!badge) { badge = document.createElement('span'); badge.className = 'mastlink__count'; badge.setAttribute('aria-hidden', 'true'); a.appendChild(badge); }
            badge.textContent = String(count);
          } else if (badge) {
            badge.parentNode.removeChild(badge);
          }
          a.setAttribute('aria-label', aria);
          return;
        }
        var t = a.querySelector('.mastlink__t');
        if (t) {
          t.textContent = label;
          a.setAttribute('aria-label', aria);
          return;
        }
        // The mobile menu link is an icon followed by a bare text node.
        for (var i = a.childNodes.length - 1; i >= 0; i--) {
          var node = a.childNodes[i];
          if (node.nodeType === 3 && /Bag/.test(node.nodeValue)) {
            node.nodeValue = label;
            break;
          }
        }
      });
    }

    // ---- open / close, focus trap ---------------------------------------
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var items = panel.querySelectorAll(FOCUSABLE);
      if (!items.length) { e.preventDefault(); panel.focus(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || active === panel || !panel.contains(active))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
        e.preventDefault();
        first.focus();
      }
    }

    function reducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function open(from) {
      opener = from || document.activeElement;
      drawer.removeAttribute('hidden');
      document.documentElement.classList.add('bag-open');
      // One frame between display and the class so the slide transition runs.
      if (window.requestAnimationFrame && !reducedMotion()) {
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      } else {
        drawer.classList.add('is-open');
      }
      document.addEventListener('keydown', onKey);
      var closeBtn = panel.querySelector('button[data-bag-close]');
      (closeBtn || panel).focus();
    }

    function close() {
      if (drawer.hasAttribute('hidden')) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('bag-open');
      document.removeEventListener('keydown', onKey);
      var finish = function () { drawer.setAttribute('hidden', ''); };
      if (reducedMotion()) finish(); else setTimeout(finish, 400);
      if (opener && typeof opener.focus === 'function') opener.focus();
      opener = null;
    }

    drawer.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      if (t.closest('[data-bag-close]')) { close(); return; }
      var rm = t.closest('[data-bag-remove]');
      if (rm) {
        var key = rm.getAttribute('data-bag-remove');
        rm.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
          .then(function (cart) {
            render(cart);
            setStatus('');
            var again = panel.querySelector(FOCUSABLE);
            if (again) again.focus();
          }, function () {
            // Could not change the bag here: the bag page can.
            window.location.href = '/cart';
          });
      }
    });

    // ---- the piece flies to the bag (13 Oct 2026, Andrew: "this is what im talking about") ----
    // On Add to bag a small copy of the piece's photo travels in a soft arc from the button to
    // the header's bag icon (about 560 ms), then the count bumps and the panel slides in. Calm:
    // one smooth curve, no spin, no bounce, the copy fades a little as it lands. Off under
    // reduced motion (the panel just opens, as before). Any trouble finding the photo, the icon
    // or the Web Animations API means no flight and the old behaviour; it can never block an add.
    function visible(r) { return r && r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < window.innerHeight && r.left < window.innerWidth; }
    function flySource() {
      var imgs = document.querySelectorAll('.gl-ql__photos img, .stage__view--photo[data-active] img, [data-stage] img, .pdp__stickybar img, .pdp__media img');
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i], src = im.currentSrc || im.src;
        if (src && im.complete && im.naturalWidth > 0) return im;
      }
      return null;
    }
    function bagTarget() {
      var links = document.querySelectorAll('a[href$="/cart"]:not([data-bag-view])');
      for (var i = 0; i < links.length; i++) {
        if (drawer.contains(links[i])) continue;
        var r = links[i].getBoundingClientRect();
        if (visible(r)) return r;
      }
      return null;
    }
    function fly(button) {
      try {
        if (reducedMotion() || !button || !document.documentElement.animate) return null;
        var im = flySource(), to = bagTarget();
        if (!im || !to) return null;
        var from = button.getBoundingClientRect();
        if (!visible(from)) return null;
        var size = 60, end = 22;
        var x0 = from.left + from.width / 2, y0 = from.top + from.height / 2;
        var x1 = to.left + to.width / 2, y1 = to.top + to.height / 2;
        // A quadratic curve whose middle point sits above both ends: the soft arc.
        var cx = (x0 + x1) / 2, cy = Math.min(y0, y1) - Math.min(120, Math.max(50, Math.abs(x1 - x0) / 5 + 40));
        var node = document.createElement('img');
        node.src = im.currentSrc || im.src;
        node.alt = '';
        node.setAttribute('aria-hidden', 'true');
        node.style.cssText = 'position:fixed;left:0;top:0;width:' + size + 'px;height:' + size + 'px;object-fit:cover;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,.22);pointer-events:none;z-index:2147483000;will-change:transform,opacity;margin:0';
        document.body.appendChild(node);
        var frames = [], n = 16;
        for (var i = 0; i <= n; i++) {
          var t = i / n, e = t * t * (3 - 2 * t);               // smoothstep: slow start, slow landing
          var x = (1 - e) * (1 - e) * x0 + 2 * (1 - e) * e * cx + e * e * x1;
          var y = (1 - e) * (1 - e) * y0 + 2 * (1 - e) * e * cy + e * e * y1;
          var sc = 1 + (end / size - 1) * e;
          frames.push({ transform: 'translate(' + (x - size / 2) + 'px,' + (y - size / 2) + 'px) scale(' + sc + ')', opacity: 1 - 0.35 * e, offset: t });
        }
        var anim = node.animate(frames, { duration: 560, easing: 'linear', fill: 'forwards' });
        return new Promise(function (resolve) {
          var done = false;
          function fin() { if (done) return; done = true; if (node.parentNode) node.parentNode.removeChild(node); resolve(true); }
          anim.onfinish = fin; anim.oncancel = fin;
          setTimeout(fin, 900);
        });
      } catch (e) { return null; }
    }

    // ---- "Questions? Text us" in the bag (13 Oct 2026) --------------------------------
    // The text is prefilled with every piece in the bag (name and stock number) and the subtotal.
    // Phones get a link (iOS `sms:+1...&body=`, Android `?body=`); a computer shows the number.
    var textEl = drawer.querySelector('[data-bag-text]');
    function phoneKind() {
      var ua = navigator.userAgent || '';
      if (/iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'ios';
      return /Android/i.test(ua) ? 'android' : '';
    }
    function textUs(cart) {
      if (!textEl) return;
      var items = cart.items || [];
      textEl.textContent = '';
      if (!items.length) { textEl.setAttribute('hidden', ''); return; }
      var tel = textEl.getAttribute('data-tel') || '', kind = phoneKind();
      if (!kind || !tel) {
        textEl.textContent = 'Questions? Text us at ' + (textEl.getAttribute('data-phone') || '');
      } else {
        var names = items.map(function (it) {
          var t = it.product_title + (it.quantity > 1 ? ' x' + it.quantity : '');
          return it.sku ? t + ' (' + it.sku + ')' : t;
        });
        var body = "Hi, I have a question about my bag: " + names.join('; ') + '. Subtotal ' + money(cart.total_price || 0) + '.';
        var a = el('a', 'textlink', 'Questions? Text us');
        a.href = 'sms:' + tel + (kind === 'ios' ? '&' : '?') + 'body=' + encodeURIComponent(body);
        textEl.appendChild(a);
      }
      textEl.removeAttribute('hidden');
    }

    // ---- the forms -------------------------------------------------------
    function refreshAndOpen(button, message, flight) {
      var pending = fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); });
      return Promise.all([pending, flight || null])
        .then(function (res) {
          var cart = res[0];
          render(cart);
          setTitle('Added to your bag');
          setStatus(message);
          if (flight && !message) {
            // The photo has landed: the count bumps first, then the panel slides in.
            added(button);
            // "Wear it with" is filled in here too: it used to come only on the reduced-motion path below (audit, 15 Oct 2026).
            return new Promise(function (resolve) { setTimeout(function () { open(button); suggest(cart); resolve(); }, 220); });
          }
          open(button);
          if (!message) { added(button); suggest(cart); }
        });
    }

    // ---- the header's bag icon and the mobile menu's bag link --------------
    // A plain click opens the panel; a modified click (new tab) or any failure
    // keeps the ordinary link to /cart.
    var bagLinks = document.querySelectorAll('a[href$="/cart"]:not([data-bag-view])');
    Array.prototype.forEach.call(bagLinks, function (a) {
      if (drawer.contains(a)) return;
      a.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
          .then(function (cart) {
            render(cart);
            setTitle('Your bag');
            setStatus('');
            open(a);
          }, function () { window.location.href = a.getAttribute('href'); });
      });
    });

    // bindForm is also used by the shelf's Quick look panel (assets/gl-shelf-touches.js), whose
    // form arrives after the page loads: window.glBag.bindForm(form).
    function bindForm(form) {
      if (form.__glBound) return;
      form.__glBound = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var button = e.submitter || form.querySelector('[type="submit"]');
        if (button && button.getAttribute('aria-busy') === 'true') return;
        if (button) button.setAttribute('aria-busy', 'true');
        var release = function () { if (button) button.removeAttribute('aria-busy'); };
        // Did Shopify answer the add itself? Once it has, whether it took the
        // piece (200) or refused it (422), the bag on the server is decided, and
        // re-sending the form would add the piece a SECOND time if only the
        // follow-up /cart.js refresh failed. That was a real bug, found by an
        // outside review on 30 Sep 2026: add OK, refresh failed, form.submit(),
        // two in the bag. So the no-script fallback is for an add that never got
        // an answer; an answered add whose refresh fails goes to the bag page,
        // which shows what is really in it.
        var answered = false;

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) {
            if (r.ok || r.status === 422) answered = true;
            if (r.ok) { var flight = fly(button); return refreshAndOpen(button, '', flight); }
            // Shopify answers a refused add with 422 and a plain-English
            // description — e.g. the piece is already in the bag. Show the
            // bag as it stands and the reason, rather than losing both.
            if (r.status === 422) {
              return r.json().then(function (j) {
                return refreshAndOpen(button, j.description || j.message || '');
              });
            }
            throw new Error('cart/add ' + r.status);
          })
          .then(release, function () {
            release();
            if (answered) {
              // The add was answered and only the refresh failed: show the bag.
              window.location.href = '/cart';
              return;
            }
            // The add itself never got an answer — offline, a 5xx, a blocked
            // request — so take the no-script route. form.submit() does not
            // fire this listener.
            form.submit();
          });
      });
    }
    window.glBag = { bindForm: bindForm };
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'), bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
